<template>
  <div id="profile-info">
    <b-row>
      <b-col lg="9" cols="12">
        <b-card>
          <router-view :key="$route.path" />
        </b-card>
      </b-col>

      <b-col lg="3" cols="12">
        <instructions-card />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import InstructionsCard from "@/components/InstructionsCard.vue";
import { BRow, BCol, BContainer, BCard, BCardText } from "bootstrap-vue";
export default {
  components: { BRow, BCol, BContainer, BCard, BCardText, InstructionsCard },
  beforeDestroy() {
    if (this.$store.hasModule("Properties"))
      this.$store.unregisterModule("Properties");
  },
};
</script>
